import { MarkdownRenderer } from '../MarkdownRenderer';
import { DataTableRenderer } from '../DataTableRenderer';
import { RecordCardRenderer } from '../RecordCardRenderer';
import { ChartRenderer } from '../ChartRenderer';
import { ErrorRenderer } from '../ErrorRenderer';
import { ConfirmationRenderer } from '../ConfirmationRenderer';
import { FileDownloadRenderer } from '../FileDownloadRenderer';
import { CodeRenderer } from '../CodeRenderer';
import { DeepLinkRenderer } from '../DeepLinkRenderer';
import { SourceDocumentsRenderer } from '../SourceDocumentsRenderer';
import { DeflectionRenderer } from '../DeflectionRenderer';
import { CalloutRenderer } from '../CalloutRenderer';
import { AgentBadgeRenderer } from '../AgentBadgeRenderer';
import { MetricRenderer } from '../MetricRenderer';
import { CitationRenderer } from '../CitationRenderer';
import { DisclaimerRenderer } from '../DisclaimerRenderer';
import { LoadingRenderer } from '../LoadingRenderer';
import { TimeoutRenderer } from '../TimeoutRenderer';
import { QuerySourceRenderer } from '../QuerySourceRenderer';
import { RecordListRenderer } from '../RecordListRenderer';
import { PartialFailureRenderer } from '../PartialFailureRenderer';
import { ProgressRenderer } from '../ProgressRenderer';
import { ToolProgressRenderer } from '../ToolProgressRenderer';
import { AgentTransitionRenderer } from '../AgentTransitionRenderer';
import { ConversationalFormRenderer } from '../ConversationalFormRenderer';
import { ExecutionPlanRenderer } from '../ExecutionPlanRenderer';
import { PlanProgressRenderer } from '../PlanProgressRenderer';
import { SubscriptionPreviewRenderer } from '../SubscriptionPreviewRenderer';
import { UpsellRenderer } from '../UpsellRenderer';
import { UsageMetricRenderer } from '../UsageMetricRenderer';
import { SourceCitationRenderer } from '../SourceCitationRenderer';
import { ResolutionConfirmationRenderer } from '../ResolutionConfirmationRenderer';
import { ZendeskTicketRenderer } from '../ZendeskTicketRenderer';
import { SupportHandoffOfferRenderer } from '../SupportHandoffOfferRenderer';
import { DayBriefRenderer } from '../DayBriefRenderer';
// ---------------------------------------------------------------------------
// Registry map: ContentBlockType → React component
// ---------------------------------------------------------------------------
const registry = new Map();
export function registerBlockRenderer(type, component) {
    registry.set(type, component);
}
export function getBlockRenderer(type) {
    const renderer = registry.get(type);
    if (!renderer && process.env.NODE_ENV === 'development') {
        console.warn(`[blockRegistry] No renderer registered for block type: "${type}"`);
    }
    return renderer || null;
}
// ---------------------------------------------------------------------------
// Register renderers
// ---------------------------------------------------------------------------
// P0 — existing + new
registerBlockRenderer('markdown', MarkdownRenderer);
registerBlockRenderer('data_table', DataTableRenderer);
registerBlockRenderer('record_card', RecordCardRenderer);
registerBlockRenderer('chart', ChartRenderer);
registerBlockRenderer('error', ErrorRenderer);
registerBlockRenderer('confirmation', ConfirmationRenderer);
registerBlockRenderer('file_download', FileDownloadRenderer);
registerBlockRenderer('code', CodeRenderer);
registerBlockRenderer('deep_link', DeepLinkRenderer);
registerBlockRenderer('deflection', DeflectionRenderer);
// P1
registerBlockRenderer('callout', CalloutRenderer);
registerBlockRenderer('agent_badge', AgentBadgeRenderer);
registerBlockRenderer('metric', MetricRenderer);
registerBlockRenderer('citation', CitationRenderer);
registerBlockRenderer('source_documents', SourceDocumentsRenderer);
registerBlockRenderer('disclaimer', DisclaimerRenderer);
registerBlockRenderer('loading', LoadingRenderer);
registerBlockRenderer('timeout', TimeoutRenderer);
registerBlockRenderer('query_source', QuerySourceRenderer);
registerBlockRenderer('record_list', RecordListRenderer);
registerBlockRenderer('partial_failure', PartialFailureRenderer);
registerBlockRenderer('progress', ProgressRenderer);
registerBlockRenderer('tool_progress', ToolProgressRenderer);
registerBlockRenderer('agent_transition', AgentTransitionRenderer);
registerBlockRenderer('conversational_form', ConversationalFormRenderer);
registerBlockRenderer('execution_plan', ExecutionPlanRenderer);
registerBlockRenderer('plan_progress', PlanProgressRenderer);
registerBlockRenderer('subscription_preview', SubscriptionPreviewRenderer);
registerBlockRenderer('upsell', UpsellRenderer);
registerBlockRenderer('usage_metric', UsageMetricRenderer);
// Support Agent (ipa-support-agent V1)
registerBlockRenderer('source_citation', SourceCitationRenderer);
registerBlockRenderer('resolution_confirmation', ResolutionConfirmationRenderer);
registerBlockRenderer('zendesk_ticket', ZendeskTicketRenderer);
registerBlockRenderer('support_handoff_offer', SupportHandoffOfferRenderer);
// Field Assistant day brief (ipa-tech-first-run-day-brief)
registerBlockRenderer('day_brief', DayBriefRenderer);
